(function TaskLists($, Adzuki)
{
	"use strict";

	$(document).ready(function onReady()
	{
		Adzuki.onload(['TaskLists/index'], function onload()
		{
			var $incomplete = null;
			var $completed  = null;
			var $filtered   = null;

			// using the task lists filter, so load only the filtered task lists
			if ($('#filtered-task-lists').length > 0) {
				$filtered = $('#filtered-task-lists');

				// filtered task lists
				Adzuki.Ajax.get('/TaskLists/filtered')
					.then(function populateFiltered(response) {
						$filtered.html(response);
						Adzuki.TableSorter.initAjax($filtered);
					}
				);

				$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
					Adzuki.TableSorter.initAjax($filtered);
				});

				$('#task_lists_filter_criteria .remove').click(function removeCriteriaItem(e) {
					_removeFilterCriteria($(this));
				});

				return;
			}

			$incomplete = $('#incomplete-task-lists');
			$completed  = $('#completed-task-lists');

			// incomplete task lists
			Adzuki.Ajax.get('/TaskLists/incomplete')
				.then(function populateIncomplete(response) {
					$incomplete.html(response);
					Adzuki.TableSorter.initAjax($incomplete);
				}
			);

			// completed task lists
			Adzuki.Ajax.get('/TaskLists/completed')
				.then(function populateCompleted(response) {
					$completed.html(response);
					Adzuki.TableSorter.initAjax($completed);
				}
			);

			// init table sort when navigating to a different page
			$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
				Adzuki.TableSorter.initAjax($incomplete);
				Adzuki.TableSorter.initAjax($completed);
			});
		});

		Adzuki.onload('TaskLists/manageTasks/', function onload()
		{
			var entity_type = $('#entity-incomplete-tasks').data('entity-type');

			Adzuki.TaskManager.loadEntityTasks(entity_type);
		});
	});

	function _removeFilterCriteria($elem)
	{
		var filter_key = $elem.data('filter-key');
		var url        = Adzuki.base_uri + '/TaskLists/clearFilter/' + filter_key;

		window.location.href = url;
	}
}(jQuery, window.Adzuki || {}));
